import { Model as t } from "../../../model.js";
class n extends t {
  constructor(i) {
    super(), this.id = i.id, this.startDate = i.startDate, this.endDate = i.endDate, this.status = i.status, this.weight = i.weight, this.name = i.name, this.description = i.description, this.triggerCondition = i.triggerCondition, this.configuration = i.configuration, this.scope = i.scope, this.audience = i.audience, this.validitySchedule = i.validitySchedule;
  }
}
export {
  n as LoyaltyProgrammeModel
};
//# sourceMappingURL=loyaltyProgramme.model.js.map
